<template>
  <article class="self-service-card wide-card service-topic-card">
    <p class="service-hint">{{ displayDescription }}</p>
    <div v-if="loading" class="muted-copy">正在加载...</div>
    <div class="topic-list" v-else-if="items.length">
      <div
        v-for="item in items"
        :key="item.entryId || item.contentId || item.title"
        class="service-topic-row"
      >
        <button type="button" @click="front.openContentDetail(item)">
          <strong>{{ item.title }}</strong>
          <span>{{ item.summary || item.category || item.moduleCode || 'CMS 内容' }}</span>
        </button>
        <div v-if="front.entryAttachments(item).length" class="service-topic-files">
          <button
            v-for="(file, fileIndex) in front.entryAttachments(item)"
            :key="file.id || file.url || fileIndex"
            type="button"
            class="cms-file-link"
            @click="front.downloadEntryAttachment(item, file)"
          >
            {{ front.attachmentLabel(file, fileIndex, front.entryAttachments(item).length) }}
          </button>
        </div>
      </div>
    </div>
    <p v-else class="muted-copy">暂无已发布内容，后续由后台 CMS 维护后展示。</p>
    <button v-if="ctaPath" type="button" class="ghost-action compact" @click="front.goPath(ctaPath)">
      {{ ctaLabel }}
    </button>
  </article>
</template>

<script>
import { listPublicCmsEntries, unwrapPublicPage } from '@/api/paleo'

const topicMeta = {
  international: {
    description: '展示国际交流、合作访问和学术互访相关内容。',
    label: '进入国际交流栏目',
    path: '/international',
    modules: ['international']
  },
  science: {
    description: '展示科普活动、科学传播文章和面向公众的资料。',
    label: '查看科学传播内容',
    path: '/services?tab=science&cat=base',
    modules: ['science']
  },
  rewards: {
    description: '展示科技奖励、申报通知和获奖成果相关内容。',
    label: '下载申报资料',
    path: '/downloads-center',
    modules: ['tech-rewards', 'awards']
  }
}

export default {
  name: 'ServiceTopicCard',
  inject: ['front'],
  data() {
    return {
      items: [],
      loading: false,
      loadSeq: 0
    }
  },
  computed: {
    meta() {
      return topicMeta[this.front.activeServiceTab] || null
    },
    displayDescription() {
      return (this.meta && this.meta.description) || ''
    },
    ctaLabel() {
      return (this.meta && this.meta.label) || '查看栏目内容'
    },
    ctaPath() {
      return this.meta && this.meta.path
    },
    modules() {
      return (this.meta && this.meta.modules) || []
    }
  },
  watch: {
    'front.activeServiceTab': {
      immediate: true,
      handler(tab) {
        if (topicMeta[tab]) {
          this.loadList()
        }
      }
    }
  },
  methods: {
    async loadList() {
      const modules = this.modules
      if (!modules.length) {
        this.items = []
        return
      }
      const seq = ++this.loadSeq
      this.loading = true
      try {
        const pages = await Promise.all(
          modules.map(moduleCode =>
            listPublicCmsEntries({ moduleCode, pageNum: 1, pageSize: 8 }).catch(() => ({ rows: [], total: 0 }))
          )
        )
        if (seq !== this.loadSeq) return
        const seen = new Set()
        const merged = []
        pages.forEach((result) => {
          const { rows } = unwrapPublicPage(result)
          ;(rows || []).forEach((row) => {
            const mapped = this.front.mapCmsEntry(row)
            const key = String(mapped.entryId || mapped.title || '')
            if (!key || seen.has(key)) return
            seen.add(key)
            merged.push(mapped)
          })
        })
        this.items = merged.slice(0, 8)
      } catch (error) {
        if (seq !== this.loadSeq) return
        this.items = []
      } finally {
        if (seq === this.loadSeq) {
          this.loading = false
        }
      }
    }
  }
}
</script>
